export const fetchVulnerabilityById = {
  pathname: id => `/api/v4/vulnerability/${id}`,
}

export const getOneVulnerability = {
  pathname: id => `/api/v4/vulnerability/${id}?rating_types=analyst,predicted,unrated&enable_next_pagination=false`
}

export const getVulnerabilityVocab = {
  pathname: () => '/api/v4/vulnerability/vocab?include_counts=true&rating_types=analyst,predicted,unrated'
}

const fieldsQuery = 'common_vulnerability_scores,cve_id,description,executive_summary,is_predicted,exploitation_state,id,aliases,mve_id,associated_reports,intel_free,observed_in_the_wild,first_publish_date,updated_date,risk_rating,sources,vulnerable_cpes,was_zero_day'

export const getVulnsData = {
  pathname: ({ limit, offset, queryString }) => `/api/v4/vulnerability?limit=${limit}&offset=${offset}&enable_next_pagination=false&fields=${fieldsQuery}&${queryString}`
}

export const fetchVulnerabilities = {
  pathname: '/api/v4/vulnerability',
  method: 'POST',
  body: (payload) => JSON.stringify(payload)
}

export const getVulnerabilityTrends = {
  pathname: () => '/api/v4/vulnerability/trend'
}
